import sortBy from 'lodash.sortby'
import upperFirst from 'lodash.upperfirst'

export function getImageTitle(image) {
  const title = image.labels[0]
  const imageIndex = image.filenameIndex

  if (title) {
    const imageNumber = imageIndex ? ` #${imageIndex}` : ''
    return `${upperFirst(title)}${imageNumber}`
  }
}

export function sortPhotos(inputPhotos, order) {
  const photos = inputPhotos.map(photo => {
    let labelIndex = order.indexOf(photo.image.labels[0])
    if (labelIndex === -1) {
      labelIndex = 999 // This ensures "unknown" labels get pushed to the end
    }
    return {
      ...photo,
      labelIndex,
    }
  })

  const sorted = sortBy(photos, ['labelIndex', 'image.filenameIndex'])
  return sorted.map(({labelIndex, ...photo}) => photo)
}
